export default __webpack_public_path__ + "static/media/quesos.11b5bbbb.jpg";